import CAD from '@assets/images/country-flags/Canada.svg';
import USD from '@assets/images/country-flags/US.svg';
import MULITCURRENCY from '@assets/images/custom/multiCurrency.svg';
import { CurrencyCodes } from '@onevesthq/ov-enums';
import { Box, Typography } from 'hephaestus/web';

export type CurrencyLabelMenuItemProp = {
  label: string;
  currency?: string | null;
  multiCurrency?: boolean;
  showAvatar: boolean;
};

/**
 * Select option content: a CAD/USD flag (or the multi-currency icon) before a truncated label.
 */
export const CurrencyLabelMenuItem = ({
  label,
  currency,
  multiCurrency = false,
  showAvatar,
}: CurrencyLabelMenuItemProp) => {
  const getCurrencyImage = () => {
    if (multiCurrency) {
      return MULITCURRENCY;
    }

    switch (currency) {
      case CurrencyCodes.CAD:
        return CAD;
      case CurrencyCodes.USD:
        return USD;
      default:
        return null;
    }
  };

  const currencyImage = getCurrencyImage();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {showAvatar && currencyImage && (
        <Box
          sx={{
            mr: 1,
            height: 20,
            width: 20,
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            borderRadius: 10,
            overflow: 'hidden',
          }}
        >
          <img
            alt={currency || 'currency'}
            src={currencyImage}
            style={{ objectFit: 'cover', height: '100%' }}
          />
        </Box>
      )}
      <Typography
        variant='bodyMedium'
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...(showAvatar ? { width: 'calc(100% - 28px)' } : {}),
          fontWeight: 500,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
